import { constants } from "@/constants";

export const footerLinks = {
  link_one: [
    { id: 1, title: "Overview", titleAr: "نظرة عامة", link: "/about-htu" },
    { id: 2, title: "Governance", titleAr: "الحوكمة", link: "/governance" },
    {
      id: 3,
      title: "President's Message",
      titleAr: "كلمة الرئيس",
      link: "/president-message",
    },
    // {
    //   id: 4,
    //   title: "Faculty Members",
    //   link: "/faculty-members",
    // },
    {
      id: 4,
      title: "News",
      titleAr: "الأخبار",
      link: "/news",
    },
    {
      id: 5,
      title: "Newsletter",
      titleAr: "النشرة الشهريّة",
      link: "/newsletter",
    },
    // { id: 7, title: "Gallery", link: "/" },
    {
      id: 6,
      title: "Vacancies",
      titleAr: "شواغر",
      link: "/vacancies",
    },
    {
      id: 7,
      title: "Contact",
      titleAr: "للتواصل",
      link: "/contact",
    },
  ],
  link_two: [
    {
      id: 1,
      title: "By-laws and Regulations",
      titleAr: "الأنظمة والتعليمات",
      link: "/by-laws-and-regulations",
    },
    {
      id: 2,
      title: "Academic Calendar",
      titleAr: "التقويم الأكاديمي",
      link: `${constants.DOCUMENTS_BASE_URL}/Students%e2%80%99%20Academic%20Calendar%20%2020242025%20(2).pdf`,
    },
    {
      id: 3,
      title: "Active Tenders and RFIs",
      titleAr: "العطاءات",
      link: "/departments/tenders-and-supplies-department#tenders-section",
    },
    {
      id: 4,
      title: "Crown Prince Foundation",
      titleAr: "مؤسّسة ولي العهد",
      link: "https://cpf.jo/",
    },
    {
      id: 5,
      title: "CAVT",
      titleAr: "كليّة التدريب المهني المتقدّم",
      link: "https://www.cavt.jo/",
    },
  ],
};

export const secondFooterLinks = {
  link_one: [
    {
      id: 1,
      key: "footer_policies",
      link: "#",
    },
    {
      id: 2,
      key: "footer_crown_prince_foundation",
      link: `https://cpf.jo/en/homepage/`,
    },
  ],
  link_two: [
    {
      id: 1,
      title: "htualumni",
      link: "https://www.instagram.com/htualumni/",
      icon: `<SocialIcons.InstagramSvg
                style={{
                  marginRight: ifArabic("0px", "8px"),
                  marginLeft: ifArabic("8px", "0px"),
                  marginBottom: "4px",
                }}
              />`,
    },
    {
      id: 2,
      title: "htu_alumni",
      link: "https://www.linkedin.com/showcase/htu-alumni/",
      icon: `<SocialIcons.LinkedinSvg
                style={{
                  marginRight: ifArabic("0px", "8px"),
                  marginLeft: ifArabic("8px", "0px"),
                  marginBottom: "4px",
                }}
              />`,
    },
  ],
};
